import {updateObject} from '../../../components/shared/utility'


const initialState = {
    companyData: [],
    error: null
};

export default function (state=initialState, action)
{
    
    const LoadCompanyInfo = (state, action)=>
    {
        return updateObject(state, {
            companyData:action.data,
           
        });
    }

    const GetNameOfSelectedRegion = (state, action) =>
    {
        return updateObject(state, {
            regionName:action.data,
        });
    }

    switch(action.type)
    {
        case "COMPANY_INFO_ACQUIRED":
            return LoadCompanyInfo(state, action);
        case "REGION_SELECTED_ACQUIRED":
            return GetNameOfSelectedRegion(state, action);

            default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/TopBar/TopBarReducer.js